<div class="page-content">
  <div class="row">
      <div class="col-lg-12">
          <div class="ibox ">
              <div class="ibox-body">
                  <div class="iboxcontent">
                      <h3>Post Job</h3>
                      <div class="stepsnumber">
                          <span>Steps 3/5</span>
                      </div>
                  </div>
                  <h6 class="heading-6">Screening questions</h6>
                  <p>We recommend adding 3 or more questions. Applicants must answer each question</p>
                  <div class="row">
                      <div class="col-sm-12 col-lg-12 col-md-12"> 
                        <form [formGroup]="form" (ngSubmit)="onSubmit()">
                          <div class="form-group">
                              <h6 class="heading-6"> Add Screening questions </h6>
                              <ul class="suggestedskills">
                                  <li *ngFor="let ques of allQuestions; let i=index;" (click)="selectedQuestion(i,$event)" [ngClass]="ques.selected == true ? 'selected' : ''">{{ques.question}}</li>
                                  <li class="showmore">
                                    <!-- <a href="javascript:void(0);" (click)="next()">Add custom Question</a> -->
                                    <input type="submit" value="Add custom question" style="background: transparent; color: #EF7E2B;"/>
                                </li>
                              </ul>
                          </div> 
                          <a href="javascript:void(0)" class="planbtn greyBtn" (click)="back()">Back</a>
                          <input type="submit" value="Continue" class="planbtn fill"/>
                        </form>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
</div>